var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUpdateIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Update_Icon_-_Integration",
    "data-name": "Update Icon - Integration",
    transform: "translate(-1205 -510)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_639",
    "data-name": "Rectangle 639",
    width: 60,
    height: 60,
    transform: "translate(1205 510)",
    fill: "rgba(255,255,255,0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "system_update_alt_FILL1_wght400_GRAD0_opsz24_1_",
    "data-name": "system_update_alt_FILL1_wght400_GRAD0_opsz24 (1)",
    d: "M86-752a5.778,5.778,0,0,1-4.238-1.763A5.778,5.778,0,0,1,80-758v-36a5.778,5.778,0,0,1,1.762-4.237A5.778,5.778,0,0,1,86-800h15v6H86v36h48v-36H119v-6h15a5.778,5.778,0,0,1,4.238,1.763A5.778,5.778,0,0,1,140-794v36a5.778,5.778,0,0,1-1.762,4.237A5.778,5.778,0,0,1,134-752Zm24-13.8-15-15,4.2-4.2,7.8,7.8V-800h6v22.8l7.8-7.8,4.2,4.2Z",
    transform: "translate(1125 1316)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdateIcon);
export default __webpack_public_path__ + "static/media/UpdateIcon.f49912cfc8e180c826e30cc9539a4219.svg";
export { ForwardRef as ReactComponent };